import type { OrderItem } from '@/types/order-list';

export const isSameOrderItem = (firstOrder: OrderItem, secondOrder: OrderItem) =>
  firstOrder.marketId === secondOrder.marketId &&
  firstOrder.storeId === secondOrder.storeId &&
  firstOrder.orderNo === secondOrder.orderNo &&
  firstOrder.orderItemNo === secondOrder.orderItemNo;
